import { render, staticRenderFns } from "./SupplyTgRightDetail.vue?vue&type=template&id=c5d8eda2&scoped=true"
import script from "./SupplyTgRightDetail.vue?vue&type=script&lang=js"
export * from "./SupplyTgRightDetail.vue?vue&type=script&lang=js"
import style0 from "./SupplyTgRightDetail.vue?vue&type=style&index=0&id=c5d8eda2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d8eda2",
  null
  
)

export default component.exports